// extracted by mini-css-extract-plugin
export default {"container":"style_container__FMY+a","svg_container":"style_svg_container__4A2bW"};